import {Auth} from 'aws-amplify';
import {useContext, useState} from 'react';
import useLogin from './useLogin';
import {CoreContext} from '@genflow/core';

export default (debug) => {
    const config = useContext(CoreContext);
    const login = useLogin();
    const { vendorUuid } = config;
    const [registering, setRegistering] = useState(false);
    const register = async (details) => {
        const {
            password, emailAddress, firstName, lastName,
        } = details;
        setRegistering(true);
        const email = emailAddress.toLowerCase().trim();
        const emailWithVendor = `${email}#${vendorUuid}`;
        const response = await Auth.signUp({
            password,
            username: emailWithVendor,
            attributes: {
                email,
                given_name: firstName,
                family_name: lastName,
            },
        });
        setRegistering(false);
        if (debug) {
            console.log('useRegister register response: ', response);
        }
        await login(email, password);
        return true;
    };
    return { register, registering };
};
